/**
 * BulkActionsBar - Bulk action controls for selected users
 */
export default function BulkActionsBar({
  selectedCount,
  onGrantCredits,
  onDeductCredits,
  onChangePlan,
  onDeleteAll,
  onClearSelection,
}) {
  if (selectedCount === 0) return null;

  return (
    <div className="bg-primary/10 border border-teal-500/20 rounded-xl p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center text-foreground font-bold">
            {selectedCount}
          </div>
          <div>
            <p className="text-foreground font-medium">{selectedCount} users selected</p>
            <p className="text-muted-foreground text-sm">Choose a bulk action</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={onGrantCredits}
            className="px-4 py-2 bg-green-600 hover:bg-green-700 text-foreground text-sm rounded-lg transition"
          >
            Grant Credits
          </button>
          <button
            onClick={onDeductCredits}
            className="px-4 py-2 bg-orange-600 hover:bg-orange-700 text-foreground text-sm rounded-lg transition"
          >
            Deduct Credits
          </button>
          <button
            onClick={onChangePlan}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-foreground text-sm rounded-lg transition"
          >
            Change Plan
          </button>
          <button
            onClick={onDeleteAll}
            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-foreground text-sm rounded-lg transition"
          >
            Delete All
          </button>
          <button
            onClick={onClearSelection}
            className="px-4 py-2 bg-muted hover:bg-slate-600 text-foreground text-sm rounded-lg transition"
          >
            Clear Selection
          </button>
        </div>
      </div>
    </div>
  );
}
